import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

const rolConfig = {
  admin:    { label:'Admin',    color:'#f87171' },
  operador: { label:'Operador', color:'#60a5fa' },
  lectura:  { label:'Lectura',  color:'var(--accent)' },
};

export default function Navbar({ usuario, onLogout }) {
  const [tema, setTema] = useState(localStorage.getItem('tema') || 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', tema);
    localStorage.setItem('tema', tema);
  }, [tema]);

  const toggleTema = () => setTema(t => t === 'dark' ? 'light' : 'dark');

  const p = usuario?.permisos || {};
  const esAdmin = usuario?.rol === 'admin';
  const rc = rolConfig[usuario?.rol] || rolConfig.lectura;

  const navStyle = {
    position:'fixed', left:0, top:0, bottom:0, width:'220px',
    background:'var(--bg3)', borderRight:'1px solid var(--border)',
    display:'flex', flexDirection:'column', padding:'1.5rem 0', zIndex:100,
    transition:'background 0.3s'
  };

  const linkStyle = {
    display:'flex', alignItems:'center', gap:'10px',
    padding:'10px 1.25rem', fontSize:'13px', color:'var(--text2)',
    textDecoration:'none', transition:'all 0.15s', fontWeight:'500'
  };

  const activeStyle = {
    color:'var(--accent)',
    background:'var(--accent3)',
    borderLeft:'3px solid var(--accent)'
  };

  return (
    <nav style={navStyle}>
      {/* Brand */}
      <div style={{padding:'0 1.25rem 1.5rem', borderBottom:'1px solid var(--border)', marginBottom:'1rem'}}>
        <div style={{fontSize:'15px', fontWeight:'900', letterSpacing:'1px', textTransform:'uppercase'}}>
          <span style={{color:'var(--accent)'}}>GREEN</span>
          <span style={{color:'var(--text)'}}> ENERGY</span>
        </div>
        <div style={{fontSize:'10px', color:'var(--text3)', marginTop:'3px', letterSpacing:'0.5px'}}>EV CHARGE MANAGEMENT</div>
      </div>

      {/* Links */}
      {p.dashboard !== false && <NavLink to="/" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})} end>🏠 Dashboard</NavLink>}
      {p.monitor !== false && <NavLink to="/monitor" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})}>📡 Monitor en vivo</NavLink>}
      {p.historial !== false && <NavLink to="/historial" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})}>📋 Historial</NavLink>}
      {p.gestion && <NavLink to="/gestion" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})}>⚙️ Gestión de carga</NavLink>}
      {p.alertas !== false && <NavLink to="/alertas" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})}>🚨 Alertas</NavLink>}
      {p.uptime !== false && <NavLink to="/uptime" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})}>📶 Uptime</NavLink>}
      {p.diagnostico !== false && <NavLink to="/diagnostico" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})}>🔬 Diagnóstico</NavLink>}
      {p.usuarios && <NavLink to="/usuarios" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})}>👥 Usuarios</NavLink>}
      {p.usuarios && <NavLink to="/errores" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})}>⚠️ Códigos error</NavLink>}
      {p.limites && <NavLink to="/limites" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})}>🔋 Límites carga</NavLink>}
      {/* Footer */}
      <div style={{marginTop:'auto', padding:'1rem 1.25rem', borderTop:'1px solid var(--border)'}}>
        <button onClick={toggleTema}
          style={{width:'100%', padding:'6px', background:'var(--bg)', border:'1px solid var(--border)',
            borderRadius:'6px', color:'var(--text2)', cursor:'pointer', fontSize:'12px', marginBottom:'10px',
            display:'flex', alignItems:'center', justifyContent:'center', gap:'6px'}}>
          {tema==='dark' ? '☀️ Modo claro' : '🌙 Modo oscuro'}
        </button>

        {/* Link a Mi Perfil */}
        <NavLink to="/perfil" style={({isActive})=>({
          display:'block', padding:'6px 8px', borderRadius:'6px', marginBottom:'6px',
          background:isActive?'var(--accent3)':'transparent',
          border:`1px solid ${isActive?'var(--accent)':'var(--border)'}`,
          textDecoration:'none'
        })}>
          <div style={{fontSize:'12px', color:'var(--text)', fontWeight:'600'}}>👤 {usuario?.nombre}</div>
          <div style={{fontSize:'11px', color:rc.color, marginTop:'1px'}}>{rc.label} · {usuario?.cop === 'todos' ? 'Todos' : usuario?.cop}</div>
        </NavLink>

        <button onClick={onLogout}
          style={{width:'100%', padding:'6px', background:'var(--bg)', border:'1px solid var(--border)',
            borderRadius:'6px', color:'var(--text3)', cursor:'pointer', fontSize:'12px'}}>
          → Cerrar sesión
        </button>
      </div>
    </nav>
  );
}
